import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { store } from "./Store/store";
import { Provider } from "react-redux";

const updateAppInfo = () => {
  // Update Page Title
  const appName = localStorage.getItem("Appname");
  if (appName) {
    document.title = appName || "E-Commerce Application";
  }

  // Update Favicon
  const faviconPath = localStorage.getItem("favIcon");
  if (faviconPath) {
    let favicon = document.getElementById("dynamic-favicon");
    if (favicon) {
      favicon.href = faviconPath;
    } else {
      // Create and append new favicon tag if not found
      favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.id = "dynamic-favicon";
      favicon.href = faviconPath;
      document.head.appendChild(favicon);
    }
  }
};

// Run function before rendering React app
updateAppInfo();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
